import React from 'react';
import logoImg from '../assets/global-ai-erp-logo.png';
import clsx from 'clsx';

export default function BrandLogo({ 
  className = "h-[46px] max-h-[47px] w-auto object-contain", 
  showBySanglob = false,
  bySanglobClassName = "text-[8px] text-slate-400 font-medium tracking-wide",
  dark = true
}) {
  return (
    <div className="inline-flex items-center h-full shrink-0 select-none">
      <img 
        src={logoImg} 
        alt="Global AI ERP" 
        className={clsx("w-auto object-contain select-none transition-all", className)} 
        loading="eager"
      />
      {showBySanglob && (
        <span className={clsx("leading-none mt-0.5 font-medium ml-1.5", bySanglobClassName)}>
          by <span className={clsx("font-bold", dark ? "text-slate-200" : "text-slate-800")}>Sanglob</span>
        </span>
      )}
    </div>
  );
}
